export enum BloodGroup {
    A_pos = 'A+',
    A_neg = 'A-',
    AB_pos = 'AB+',
    AB_neg = 'AB-',
    B_pos = 'B+',
    B_neg = 'B-',
    O_pos = 'O+',
    O_neg = 'O-'
}